// extracted by mini-css-extract-plugin
export var contentBody = "_8m-9";
export var headerImage = "_8m-2";
export var imageButton = "_8m-7";
export var imageButtonIcon = "_8m-8";
export var imageHeader = "_8m-4";
export var imageHeaderText = "_8m-5";
export var imageOverlay = "_8m-3";
export var imageTitle = "_8m-6";
export var imageWrapper = "_8m-1";
export var taskList = "_8m-a";
export var widget = "_8m-0";